export enum VisionTimeFormatType {
  H12 = 'h12',
  H24 = 'h24',
}
